export enum EcosystemLinks {
  Demex = 'https://app.dem.exchange/trade',
  DemexScan = 'https://scan.dem.exchange/dashboard',
}

export enum ResourceLinks {
  Docs = 'https://docs.dem.exchange/',
  GitHub = 'https://github.com/Switcheo/carbon-bootstrap',
}

export enum SocialMediaLinks {
  Twitter = 'https://x.com/demexchange',
  Telegram = 'https://t.me/demex_community',
  Discord = 'https://discord.com/invite/SPh62Hf',
  Reddit = 'https://www.reddit.com/r/Demex/',
}
